


































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import M from "materialize-css";
import { Length } from "@/utils/states";

@Component
export default class RulerModal extends Vue {
  @Prop() private open!: boolean;

  public data: Length = {
    length: 20,
    cm: true
  };

  mounted() {
    M.Modal.init(this.$refs.modal as Element, {
      dismissible: false,
      onCloseEnd: () => {
        const length = this.data.length;
        this.data.length = length <= 0 || isNaN(length) ? 20 : length;
        this.$emit("length-selected", this.data);
      }
    });
  }

  @Watch("open")
  openModal() {
    if (this.open) {
      const modal = M.Modal.getInstance(this.$refs.modal as Element);
      modal.open();
    }
  }
}
